/**
 * Storefront-wide approvals list (Approvals dashboard).
 * Thin wrapper around useApprovals without a product scope.
 */
import type { ApprovalsQueryParams } from "../../../../../types/types.Workflow";
import { useApprovals } from "./useApprovals";

export function useStorefrontApprovals(params: ApprovalsQueryParams = {}) {
  return useApprovals({ limit: 20, ...params });
}
